// extracted by mini-css-extract-plugin
module.exports = {"container":"ski-resort_container__Xw_3c","ad_container":"ski-resort_ad_container__J7wtu","main_content":"ski-resort_main_content__Njkuw","wrapper":"ski-resort_wrapper__SXgxM"};